class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search__results');
    this.overlay = this.querySelector('.predictive-search__overlay');
    this.closeButton = this.querySelector('.close-search__button')
    this.isOpen = false;
    this.controller = new AbortController();
    this.working = false;
    this.hasPlaceholder = false;
    this.timeoutQuery;
    this.lastQueryId = 0;
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', (event) => {
      if (window.innerWidth < 750 && window.scrollY < 40) {
        document.querySelector('.header-wrapper').scrollIntoView({
          behavior: 'smooth', 
          block: 'start'
        });
      }
      this.open();
      this.setLiveRegionLoadingState();
      if(this.timeoutQuery) {
        clearTimeout(this.timeoutQuery);
        this.working = false;
      }
      this.timeoutQuery = setTimeout(this.onChange.bind(this), 300);
    });
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.overlay.addEventListener('click', this.onClickOverlay.bind(this));
    this.closeButton.addEventListener('click', this.onClickOverlay.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    
    if (searchTerm.length < 2) {
      this.predictiveSearchResults.innerHTML = '';
      return;
    }

    if (!searchTerm.length) {
      this.querySelector(".predictive-search__results-suggestions").classList.remove("hidden")
      this.querySelector(".predictive-search__results-generated").classList.add("hidden")
    } else {
      this.querySelector(".predictive-search__results-suggestions").classList.add("hidden")
      this.querySelector(".predictive-search__results-generated").classList.remove("hidden")
    }
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    this.open();

    this.lockScroll()
    document.querySelector(".header").classList.add(`force-header-top`);
    this.header = this.header || document.querySelector('.section-header');
    this.headerContent = document.querySelector('.header');
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.headerContent.getBoundingClientRect().bottom)}px`);

    if (!searchTerm.length) {
      this.querySelector(".predictive-search__results-suggestions").classList.remove("hidden")
      this.querySelector(".predictive-search__results-generated").classList.add("hidden")
    } else {
      this.querySelector(".predictive-search__results-suggestions").classList.add("hidden")
      this.querySelector(".predictive-search__results-generated").classList.remove("hidden")
    }

    if (this.getAttribute('results') === 'true') {
      // this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onClickOverlay() {
    this.close();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const currentQueryId = ++this.lastQueryId;
    
    if (!this.working) {
      this.controller.abort();
      this.controller = new AbortController();
    }
    const signal = this.controller.signal;
    this.working = true;

    window.__algoliaClient = window.__algoliaClient || algoliasearch('QCNY1XYTZF', '3efc3d956ce6cda98bb9bc7bdcd516be');
    const client = window.__algoliaClient;
    let productsIndex = 'shopify_products'
    if (Shopify.locale != 'de') {
      productsIndex = `shopify_products_deutschland_${Shopify.locale}`
    }
    const indexProducts = client.initIndex(productsIndex);

    const productSearchPromise = indexProducts.search(searchTerm, {
      hitsPerPage: 10,
      attributesToRetrieve: ['title', 'product_image', 'product_type', 'price', 'compare_at_price', 'handle', 'variants_min_price', 'variants_max_price', 'free_addon'],
      clickAnalytics: true,
      analyticsTags: ['predictive']
    });
    const collectionsIndex = Shopify.locale != 'de' ? `shopify_collections_deutschland_${Shopify.locale}` : 'shopify_collections';
    const collectionSearchPromise = client.initIndex(collectionsIndex).search(searchTerm, { hitsPerPage: 5, clickAnalytics: true, analyticsTags: ['predictive'] });

    Promise.all([productSearchPromise, collectionSearchPromise])
      .then(([productResults, collectionResults]) => {
        if (currentQueryId !== this.lastQueryId) return;
        this.cachedResults[queryKey] = productResults.hits;
        this.renderSearchResults(productResults, searchTerm);
      })
      .catch((error) => {
        this.close();
        console.error("Search error:", error);
      })
      .finally(() => {
        this.working = false;
      });
  }

  setLiveRegionLoadingState() {
    this.setAttribute('loading', true);
    if(!this.hasPlaceholder) {
      const temp = document.getElementById("predictive-search-placeholder-tpl");
      const placeholder = temp.content.cloneNode(true);
      this.querySelector('.predictive-search__loading-state').append(placeholder);
      this.hasPlaceholder = true;
    }
  }

  renderSearchResults(productResults, searchTerm) {
    window.__algoliaClient = window.__algoliaClient || algoliasearch('QCNY1XYTZF', '3efc3d956ce6cda98bb9bc7bdcd516be');
    const client = window.__algoliaClient;
    
    const productHits = productResults && productResults.hits ? productResults.hits : [];
    let productsIndexName = 'shopify_products'
    if (Shopify.locale != 'de') {
      productsIndexName = `shopify_products_deutschland_${Shopify.locale}`
    }
    
    // Create promises for both product and collection searches
    const productSearchPromise = Promise.resolve(productHits); // Use the already fetched product hits
    let collectionsIndex = 'shopify_collections'
    if (Shopify.locale != 'de') {
      collectionsIndex = `shopify_collections_deutschland_${Shopify.locale}`
    }
    const collectionSearchPromise = client.initIndex(collectionsIndex).search(searchTerm, { hitsPerPage: 5, clickAnalytics: true, analyticsTags: ['predictive'] });

    Promise.all([productSearchPromise, collectionSearchPromise])
      .then(([productHits, collectionResults]) => {

        const getTitleFullMatchHits = hits => {
          return hits.filter(hit => {
            return hit._highlightResult?.title?.matchLevel === "full";
          });
        };
        
        const productFullMatches = getTitleFullMatchHits(productHits);
        const collectionFullMatches = getTitleFullMatchHits(collectionResults.hits);
        let productFullMatch = false;

        const filteredCollectionHits = collectionResults.hits.filter(hit => !hit.title.toLowerCase().includes("bundle"));
        
        if (productFullMatches.length && !collectionFullMatches.length) {
          productFullMatch = true;
        }

        

        // Render the product search results
        this.predictiveSearchResults.innerHTML = `
        <a href="${window.routes.search_url}?q=${searchTerm}&options%5Bprefix%5D=last" tabindex="-1" role="option" aria-selected="false" class="predictive-search__header h5 margin0 link w100 flex justify-space-between align-center break">
          <span>${window.search.resultsFor} "${searchTerm}"</span> 
          <svg class="icon icon-revert-in-rtl icon-revert-in-rtl" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M14 5L21 12M21 12L14 19M21 12L3 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </a>
        ${filteredCollectionHits.length > 0 && !productFullMatch ? `
        <div class="predictive-search__results-list flex flex-column">
           <div class="predictive-search__group predictive-search__group--with-media predictive-search__group--collection">
            <h3 class="predictive-search__heading predictive-search__padding caption lh1 font-heading-bold margin0">${window.search.collections}</h3>
            <ul class="list-unstyled predictive-search__item-list flex flex-column">
            ${filteredCollectionHits.map(hit => `
                  <li>
                    <a class="predictive-search__collection predictive-search__item por full-unstyled-link predictive-search__item--empty" href="${Shopify.locale !== 'de' ? '/' + Shopify.locale : ''}/collections/${hit.handle}">
                      <div class="predictive-search__item__info">
                        <p class="h6 predictive-search__item__title card__heading">
                          ${hit._highlightResult.title.value}
                        </p>
                        <div class="margin-top-1rem">
                          <span class="caption db font-heading-bold light">
                            
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                `).join('')}
            </ul>
          </div>
        </div>
        ` : ''}
        ${productHits.length > 0 ? `
          <div class="predictive-search__group predictive-search__group--with-media">
            <h3 class="predictive-search__heading predictive-search__padding caption lh1 font-heading-bold margin0">${window.search.products}</h3>
            <ul class="list-unstyled predictive-search__item-list flex flex-column">
              ${productHits.map((hit, i) => {
                const isUK = window.Shopify.country === 'GB';
                const isEU = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'].includes(window.Shopify.country);
                const vatThresholdCents = 135; 
                const cartTotalCents = window.cart.cart_total || 0;
                const productPriceCents = hit.price;
                const totalCents = cartTotalCents + productPriceCents;

                const applyVATAdjustment = !isEU;
                console.log("hit", hit)


                const exchangeRate = (isUK && totalCents < vatThresholdCents || isEU) ? 1 : 1.19;

                

                const adjustedPrice = applyVATAdjustment ? hit.price * Shopify.currency.rate / exchangeRate : hit.price;
                const adjustedCompareAt = applyVATAdjustment && hit.compare_at_price ? hit.compare_at_price * Shopify.currency.rate / exchangeRate : hit.compare_at_price;
                const adjustedMin = applyVATAdjustment ? hit.variants_min_price * Shopify.currency.rate / exchangeRate : hit.variants_min_price;
                const adjustedMax = applyVATAdjustment ? hit.variants_max_price * Shopify.currency.rate / exchangeRate : hit.variants_max_price;
                return `
                  <a class="predictive-search__product predictive-search__item por full-unstyled-link" href="${Shopify.locale !== 'de' ? '/' + Shopify.locale : ''}/products/${hit.handle}" data-algolia-object-id="${hit.objectID}" data-algolia-position="${i + 1}" data-algolia-index="${productsIndexName}" data-algolia-query-id="${productResults.queryID || ''}">
                    <div class="predictive-search__product__media-wrapper">
                      <use-animate class="media media--square">
                        <img src="${hit.product_image}" width="150" height="150" class="predictive-search__product__image motion-reduce" loading="lazy" />
                      </use-animate>
                    </div>
                    <div class="predictive-search__item__info">
                      <p class="h6 predictive-search__item__title card__heading font-heading-bold">
                        ${hit.title}
                      </p>
                      <p class="caption predictive-search__item__type">
                        ${hit.product_type}
                      </p>
                      <div class="margin-top-1rem">
                        <div class="price ${hit.compare_at_price > hit.price ? 'price--on-sale' : ''} price--small">
                          <div class="price__container${hit.compare_at_price > hit.price ? ' break' : ''}">
                            <div class="price__regular">
                              <span class="visually-hidden visually-hidden--inline">Regular Price</span>
                              <span class="price-item price-item--regular ${hit.free_addon ? 'free-addon' : ''}">
                                ${Shopify.formatMoney(adjustedPrice * 100)}
                              </span>
                            </div>
                            ${hit.compare_at_price > hit.price ? `
                            <div class="price__sale">
                              <span class="visually-hidden visually-hidden--inline">Regular Price</span>
                              <span class="flex align-center">
                                <s class="price-item price-item--regular">
                                  ${Shopify.formatMoney(adjustedCompareAt * 100)}
                                </s>
                              </span>
                              <span class="visually-hidden visually-hidden--inline">Sale Price</span>
                              <span class="price-item price-item--sale price-item--last">
                                ${Shopify.formatMoney(adjustedPrice * 100)} 
                              </span>
                            </div>
                            ` : ''}
                            ${hit.variants_count > 0 && hit.variants_min_price !== hit.variants_max_price ? `
                            <small class="unit-price caption">
                              <span class="visually-hidden">Unit Price</span>
                              <span class="price-item price-item--last">
                                ${Shopify.formatMoney(adjustedMin * 100)} - ${Shopify.formatMoney(adjustedMax * 100)} 
                              </span>
                            </small>
                            ` : ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              `}).join('')}
            </ul>
          </div>
           ` : ''}
        </div>
        <div class="center predictive-search__search-url element-small-margin-top break">
          <a href="${window.routes.search_url}?q=${searchTerm}&options%5Bprefix%5D=last" class="predictive-search__button">
            <span>${window.search.viewAllResults}</span>
          </a>
        </div>
        <div class="predictive-search__shadow">
        </div>
        `; 
        this.setAttribute('results', true);
        this.setLiveRegionResults();
        try {
          if (window.aa && productResults && productResults.queryID) {
            this.querySelectorAll('a.predictive-search__product').forEach((link) => {
              link.addEventListener('click', () => {
                const objectID = link.getAttribute('data-algolia-object-id');
                const position = Number(link.getAttribute('data-algolia-position')) || 1;
                const index = link.getAttribute('data-algolia-index');
                const queryID = link.getAttribute('data-algolia-query-id');
                if (objectID && index && queryID) {
                  window.aa('clickedObjectIDsAfterSearch', {
                    eventName: 'Predictive Search Click',
                    index,
                    queryID,
                    objectIDs: [objectID],
                    positions: [position]
                  });
                }
              });
            });
          }
        } catch (e) {
          console.warn('Algolia insights click binding failed', e);
        }
      })
      .catch((error) => {
        console.error("Search error:", error);
      });
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
  }

  open() {
    if(!this.isOpen) {
      if(!this.classList.contains('run-top')) {
        this.classList.add('run-top');
      }
      
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
    }
  }

  lockScroll() {
    document.documentElement.classList.add('overflow-hidden-mobile'); // html
    document.body.classList.add('overflow-hidden-mobile'); // body
  }

  unlockScroll() {
    document.documentElement.classList.remove('overflow-hidden-mobile'); // html
    document.body.classList.remove('overflow-hidden-mobile'); // body
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    this.unlockScroll()
    document.querySelector(".header").classList.remove(`force-header-top`);
    
    this.classList.remove('run-top');

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
   
    this.isOpen = false;
    if(this.nextElementSibling && this.nextElementSibling.classList.contains('search-modal__close-button')) {
      this.nextElementSibling.dispatchEvent(new Event('click'));
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
